import type {BasicObject} from '@/types';
import type {LotteryOrderTicket} from '../mix-lottery/mix-lottery-service';

export type BetsStatus = 0 | 1 | 2 | 3 | 4;
export type PickStatus = 0 | 1 | 2;

const isPickStatus = (value: unknown): value is PickStatus => {
  return value === 0 || value === 1 || value === 2;
};

export const getDigitPickStatus = (
  info: BasicObject,
  isOpen?: boolean,
): PickStatus => {
  if (isPickStatus(info.pickStatus)) {
    return info.pickStatus;
  }
  const isDrawn =
    typeof isOpen === 'boolean'
      ? isOpen
      : typeof info.wonCode === 'string' &&
        Boolean(info.wonCode) &&
        !info.wonCode.startsWith('*');
  if (isDrawn) {
    return info.winAmount > 0 ? 1 : 0;
  }
  return 2;
};

export const getBetsDetailStatus = (
  info: BasicObject,
  game?: string,
): BetsStatus => {
  const {shareGameDto = {}} = info || {};
  const {gameCode} = shareGameDto;
  if (gameCode === 'kerala') {
    if (info.bonusStatus === 0) {
      return info.wonAmount > 0 ? 1 : 0;
    }
    return info.bonusStatus;
  }
  if (gameCode === 'pick3' || gameCode === '3Digit') {
    return getDigitPickStatus(info);
  }
  if (gameCode === 'quick 3digit' || gameCode === 'digit5') {
    const isOpen =
      typeof info.wonCode === 'string' &&
      Boolean(info.wonCode) &&
      !info.wonCode.startsWith('*');
    return isOpen ? (info.winAmount > 0 ? 1 : 0) : 2;
  }
  if (gameCode === 'color') {
    if (info.openStatus === 1) {
      return 2;
    }
    return info.awardAmount > 0 ? 1 : 0;
  }
  if (gameCode === 'matka') {
    if (info.openStatus === 1) {
      return 2;
    }
    return info.wonAmount > 0 ? 1 : 0;
  }
  if (gameCode === 'dice') {
    if (info.openStatus === 1) {
      return 2;
    }
    return info.totalAwardAmount > 0 ? 1 : 0;
  }
  if (gameCode === 'lottery official india') {
    const allDrawn =
      Array.isArray(info.wonCode) &&
      info.wonCode.every((value: string) => value.indexOf('-') === -1);
    if (!allDrawn) {
      return 2;
    }
    const allSettled =
      Array.isArray(info.ticketsLists) &&
      info.ticketsLists.every(
        (ticket: LotteryOrderTicket) => ticket.ticketStatus === 2,
      );
    if (game === 'Quick State Lottery' || allSettled) {
      return info.totalPrize > 0 ? 4 : 0;
    }
    return 3;
  }
  if (info.orderStatus !== undefined && info.openStatus !== undefined) {
    if (info.openStatus === 2) {
      return 2;
    }
    return info.orderStatus;
  }
  return info.orderStatus;
};
